const queryKeyFactory = {
  studyDetails: (studyId: string) => ['study', studyId, 'details'],
}

export default queryKeyFactory
